{
  "dataFieldsInTooltip": {
    "title": "Rótulo flutuante do objeto",
    "tooltip": "Escolha até 5 valores de atributos para mostrar ao passar o mouse sobre um objeto de mapa.",
    "tooltipAttributeTypes": "Os tipos de atributos suportados são: Texto, Número, Lista e What3Words",
    "error": "Algo deu errado, entre em contato com o suporte se o problema persistir"
  },
  "tooltipShortcuts": {
    "select_object": "Pressione V",
    "draw": "Pressione D",
    "measure": "Pressione M",
    "undo": "Ctrl+Z",
    "redo": "Ctrl + Shift + Z",
    "comment": "Pressione C",
    "copy_paste": "Ctrl + C/Ctrl + V",
    "delete_object": "Pressione Del",
    "cancel_drawing": "Pressione Esc ou clique com o botão direito",
    "confirm_drawing": "Pressione Enter ou clique duas vezes"
  },
  "draw": {
    "polygon": "Polígono",
    "line": "Linha",
    "rectangle": "Retângulo",
    "routePlanner": "Planejador de rotas",
    "point": "Ponto",
    "model": "modelo",
    "icon": "Ícone"
  },
  "select": {
    "select_object": "Selecionar objeto",
    "select_area": "Selecionar objetos dentro da área"
  },
  "drawRoute": "Desenhe a rota",
  "drawLineRectangle": "Desenhe um retângulo de linha",
  "layerOptionsTooltips": {
    "lock_layer": "Camada de bloqueio",
    "unlock_layer": "Desbloqueie a camada",
    "cannot_lock_layer_while_editing": "Você não pode bloquear uma camada enquanto a está editando"
  },
  "sitemapVersion": {
    "perimeter": "Perímetro",
    "drawOutsideCADPerimeter": "Não é possível desenhar fora do limite neste nível"
  },
  "map_objects": "objetos de mapa",
  "map_object": "objeto de mapa",
  "plan": "plano",
  "map_layer": "camadas do mapa",
  "layers": "camadas",
  "layer": "camada",
  "layer_data_field": "campo de dados da camada",
  "layer_geoJson": "camada como GeoJSON",
  "route_waypoints": "pontos de referência da rota",
  "map_objects_attribute_values": "valores de atributos de objetos de mapa",
  "saved_map_view": "visualização de mapa salva",
  "map_object_geometry": "geometria do objeto de mapa",
  "map_background": "plano de fundo do mapa",
  "map_sidebar_order": "ordem da barra lateral do mapa",
  "map_comment": "comentário no mapa",
  "model": "modelo",
  "snapping": {
    "snapToDraw": "Encaixar no objeto"
  },
  "drawMapObjectTooltip": "Clique para adicionar outro objeto a essa camada",
  "exports2": {
    "title": "Título",
    "imageUpload": {
      "title": "Logotipo personalizado"
    }
  },
  "digitalTwin": {
    "occupiedTable": {
      "id": "ID do servidor",
      "status": "Status",
      "user": "Usuário"
    },
    "status": {
      "Occupied": "Em uso",
      "Available": "Disponível",
      "Starting": "Começando",
      "Stopped": "Parado",
      "Error": "Erro"
    },
    "occupiedPopup": {
      "header": "No momento, todos os servidores gêmeos digitais estão indisponíveis",
      "message": "Tente novamente mais tarde ou entre em contato com {{ supportEmail }} para obter mais informações"
    }
  },
  "fileUpload": {
    "invalid_compression_size": "O arquivo que você está tentando enviar é muito grande e não pôde ser compactado."
  }
}